export const SAMPLE_INTERVIEWS = [
  {
    id: "sample-1", title: "Fire Chief on the new Yulee station", source: "Fire Chief (sample)", date: "Today, 10:42 AM", length: "08:14",
    lines: [
      { t: "00:04", who: "Reporter", text: "Thanks for making time, Chief. What does the new station change for Yulee residents?" },
      { t: "00:11", who: "Source", text: "Response times, mostly. We expect to shave three to four minutes off calls on the west side of the county." },
      { t: "00:26", who: "Reporter", text: "How many firefighters will be stationed there?" },
      { t: "00:30", who: "Source", text: "We'll staff it around the clock with a crew of six per shift once we finish hiring this spring." },
      { t: "00:47", who: "Reporter", text: "And the six million dollar price tag — where did that funding come from?" },
      { t: "00:52", who: "Source", text: "A mix of impact fees and the county's capital budget. No new taxes were needed for this one." },
    ],
  },
  {
    id: "sample-2", title: "Pirates head coach after the Andrew Jackson game", source: "Head Coach (sample)", date: "Oct 18, 9:15 PM", length: "04:37",
    lines: [
      { t: "00:03", who: "Reporter", text: "Coach, tough loss tonight. What happened in the fourth quarter?" },
      { t: "00:08", who: "Source", text: "We had our chances. Two turnovers in the red zone, and you can't do that against a team like this." },
    ],
  },
];
